import { lazy } from "react";

export const FavoriteButton = lazy(() =>
    import("@/features/saved-listings").then((module) => ({
        default: module.FavoriteButton,
    })),
);
